var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20944_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25045 11.2907C1.11505 11.4261 1.01657 11.5861 0.955023 11.7646L0.0687492 14.3681C-0.257449 15.3282 0.653444 16.2514 1.61357 15.9375L4.24162 15.0759C4.42626 15.0143 4.5986 14.9097 4.734 14.7743L11.7688 7.7087L8.28525 4.21899L1.25045 11.2907ZM8.28722 6.48571L2.44195 12.3617L1.821 14.1857L3.66374 13.5815L9.50952 7.71017L8.28722 6.48571Z",
    fill: "#545C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6462 2.12029L13.8859 0.360049C13.4059 -0.120016 12.6242 -0.120016 12.1442 0.360049L9.51611 2.9881L13.0181 6.49011L15.6462 3.86206C16.1262 3.382 16.1262 2.60035 15.6462 2.12029Z",
    fill: "#545C62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20944_1567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b2609cf42100e632d4bbcecfd1657a5b.svg";
export { ForwardRef as ReactComponent };